// eslint-disable-next-line import/prefer-default-export
export function getSortParams(sort) {
  const params = {};
  if (sort) {
    const sortParam = Object.entries(sort).map(([field, direction]) => `${field}|${direction}`);
    params.sort = sortParam.length > 1 ? sortParam : sortParam[0];
  }
  return params;
}
